// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDQ4ZktOO0G0EJrdKe5UJ8Nq5jlKdLaML4",
  authDomain: "flownow-33ce2.firebaseapp.com",
  projectId: "flownow-33ce2",
  storageBucket: "flownow-33ce2.firebasestorage.app",
  messagingSenderId: "737278727397",
  appId: "1:737278727397:web:b0836427a92e9f8274700c",
  measurementId: "G-STWRJBT92F"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app);

export { auth, db };